import {
  Channel,
  QueueStatsFilterDefinition,
  VolumeAggregationDimensionExtended,
} from 'types'

import { aggregationDimensionOptionsMap, DimensionOption } from '../consts'

export type CountByOptionValue =
  | { value: VolumeAggregationDimensionExtended; parentKey?: never }
  | {
      value: string
      parentKey: VolumeAggregationDimensionExtended
    }
export type CountByOption = Omit<DimensionOption, 'value'> & {
  value: string
}

const prepareOption = (option: DimensionOption, label?: string) => ({
  ...option,
  label: label || option.label,
  value: JSON.stringify({
    value: option.value,
  }),
})

export const calculateCountByOptions = (
  channel: Channel,
  additionalFilters?: QueueStatsFilterDefinition[],
): CountByOption[] => {
  const filtersMap = new Map(additionalFilters?.map(filter => [filter.key, filter]) ?? [])
  const basicOptions = aggregationDimensionOptionsMap[channel]

  return basicOptions.flatMap(option => {
    const optionFilter = option.filterKey && filtersMap.get(option.filterKey)
    const preparedOption = prepareOption(option, optionFilter?.label)

    if (optionFilter && option.filterKey && option.filterChildKey) {
      const childOptions = optionFilter.values.map(optionFilterValue => ({
        key: optionFilterValue.id,
        value: JSON.stringify({
          value: optionFilterValue.id,
          parentKey: option.filterChildKey!,
        }),
        label: optionFilterValue.label,
      }))

      return [preparedOption, ...childOptions]
    }

    return preparedOption
  })
}
